module.exports = __webpack_public_path__ + "static/media/plan-illegal-move-icon@3x.e83dfb67.png";